export const defaultMeasureOfWeightlist = [
  { key: '1', value: '1', text: 'гр.' },
  { key: '2', value: '2', text: 'мл.' },
  { key: '3', value: '3', text: 'ч.л.' },
  { key: '4', value: '4', text: 'ст.л.' },
  { key: '5', value: '5', text: 'шт.' },
  { key: '6', value: '6', text: 'по вкусу' },
];

export const default_activity = [
  'Низкая или отсутствует',
  'Невысокая активность (1-3 тренировки в неделю)',
  'Умеренная активность (4-5 тренировок в неделю)',
  'Высокая активность (6-7 тренировок в неделю)',
  'Экстремально высокая активность (2 и более тренировок в день)',
];

export const default_country = ['США', 'Европа', 'Израиль', 'Украина'];

export const default_gender = ['Женский', 'Мужской'];

export const one = 1;
export const product_tags_id = 1;
export const dish_tags_id = 2;
export const eating_tags_id = 3;
export const dish_portion_count = 4;

export const defualt_portion = [
  {
    key: 1,
    text: 'small',
    value: 'small',
    ru_value: 'маленькая',
  },
  {
    key: 2,
    text: 'medium',
    value: 'medium',
    ru_value: 'средняя',
  },
  {
    key: 3,
    text: 'big',
    value: 'big',
    ru_value: 'увеличенная',
  },
  {
    key: 4,
    text: 'large',
    value: 'large',
    ru_value: 'большая',
  },
];

export const snackId = 16;
export const breakfastTagId = 18;
export const lunchTagId = 20;
export const dinnerTagId = 22;
export const breakfastSnackId = 19;
export const lunchSnackId = 21;
export const dinnerSnackId = 23;

export const defaultGenerationModes = [
  {
    key: 1,
    text: 'Разные дни',
    value: 1,
  },
  {
    key: 2,
    text: 'Повторы по 2 дня',
    value: 2,
  },
  {
    key: 3,
    text: 'Повторы по 3 дня',
    value: 3,
  },
];

export const defaultCourseDuration = [
  {
    key: 30,
    text: '30 дней',
    value: 30,
  },
  {
    key: 37,
    text: '37 дней',
    value: 37,
  },
];

export const proteinTagId = 15;
export const carbohydrateTagId = 13;
export const vegetableTagId = 50;
export const saladTagId = 17;
export const FruitTagId = 52;

export const fullStructureMenuTags = [
  proteinTagId,
  carbohydrateTagId,
  vegetableTagId,
  saladTagId,
  FruitTagId,
];

export const breakfastTags = [
  { id: proteinTagId, name: 'Белковое' },
  { id: carbohydrateTagId, name: 'Углеводное' },
  { id: vegetableTagId, name: 'Овощное' },
  { id: saladTagId, name: 'Салат' },
  { id: FruitTagId, name: 'Фруктовое' },
];
export const dinnerTags = [
  { id: proteinTagId, name: 'Белковое' },
  { id: carbohydrateTagId, name: 'Углеводное' },
  { id: vegetableTagId, name: 'Овощное' },
  { id: saladTagId, name: 'Салат' },
];

export const defaultProductRow = {
  product_id: '',
  small: 0,
  medium: 0,
  big: 0,
  large: 0,
  measure: '',
  error: false,
  tags: [],
  calories: 0,
  proteins: 0,
  fats: 0,
  carbohydrates: 0,
};

export const defaultEatingTitle = [
  { text: 'Завтрак', value: breakfastTagId },
  { text: 'Утренний перекус', value: breakfastSnackId },
  { text: 'Обед', value: lunchTagId },
  { text: 'Дневной перекус ', value: lunchSnackId },
  { text: 'Ужин', value: dinnerTagId },
  { text: 'Вечерний перекус', value: dinnerSnackId },
];

export const defaultEating = [
  'breakfast',
  'morningSnack',
  'lunch',
  'afternoonSnack',
  'dinner',
  'eveningSnack',
];

export const defaulIsDraftArray = [
  { text: 'Черновик', value: true },
  { text: 'Опубликовано', value: false },
  { text: 'Все', value: 'all' },
];

export const taste = '6';
export const tasteValue = 'по вкусу';

export const teaSpoon = '3';
export const teaSpoonValue = 'ч.л.';

export const tableSpoon = '4';
export const tableSpoonValue = 'ст.л.';

export const defaultValue = 'кардио';
export const defaultComplexity = 'средняя';
export const defaultTemplate = 'шаблон 1';

export const DEFAULT_TYPE_PAYMENT = [
  {
    id: 1,
    name: 'Manual',
  },
  {
    id: 2,
    name: 'Subscription',
  },
];

export const defaultNormalUpTo65='марафон 2022-06 до 65 полный';
// }];
// export const defaultNormalUpTo65 = [{
//   id: 230,
//   key: 230,
//   value:"марафон 2022-06 до 65 полный",
//   name:"марафон 2022-06 до 65 полный",
// }];
export const defaultNormalFrom65To80 = "марафон 2022-06 от 65 до 80 полный";
//  [{
//   id: 231,
//   key: 231,
//   value:"марафон 2022-06 от 65 до 80 полный",
//   name:"марафон 2022-06 от 65 до 80 полный",
// }];
export const defaultNormalFrom80 ="марафон 2022-06 от 80 полный";
// [{
//   id: 232,
//   key: 232,
//   value:"марафон 2022-06 от 80 полный",
//   name:"марафон 2022-06 от 80 полный",
// }];
export const defaultSimplifiedlUpTo65 = "марафон 2022-06 до 65 упрощенный";
// [{
//   id: 233,
//   key: 233,
//   value:"марафон 2022-06 до 65 упрощенный",
//   name:"марафон 2022-06 до 65 упрощенный",
// }];
export const defaultSimplifiedFrom65To80 = "марафон 2022-06 от 65 до 80 урощенный";
// [{
//   id: 234,
//   key: 234,
//   value:"марафон 2022-06 от 65 до 80 урощенный",
//   name:"марафон 2022-06 от 65 до 80 урощенный",
// }];
export const defaultSimplifiedFrom80 ="марафон 2022-06 от 80 упрощенный";
//  [{
//   id: 235,
//   key: 235,
//   value:"марафон 2022-06 от 80 упрощенный",
//   name:"марафон 2022-06 от 80 упрощенный",
// }];


// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/youslim2.0_Constants.js